import { render, staticRenderFns } from "./ViewBatchStats.vue?vue&type=template&id=57ac559a&scoped=true"
import script from "./ViewBatchStats.vue?vue&type=script&lang=js"
export * from "./ViewBatchStats.vue?vue&type=script&lang=js"
import style0 from "./ViewBatchStats.vue?vue&type=style&index=0&id=57ac559a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ac559a",
  null
  
)

export default component.exports